import Sponsors from "./Sponsors";

export default Sponsors;
